import styled, { css } from 'styled-components';
import Icon from '@anwb/icon';
import Spinner, { SpinnerSVG, SpinnerText } from '@anwb/spinner';
import { stylePropertiesToCss } from '@anwb/style-mixins';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
import { getGenericInputPaddingStyles, getOnDarkStyles, getOnLightStyles, getOnMediumStyles, } from '../../../styles/common.styled';
const SPINNER_SIZE = 30;
const INPUT_HEIGHT = 56;
export const inputContainerStyles = ({ theme }) => css `
	appearance: none;
	margin: 0;
	padding: 0;
	width: 100%;
	border: none;
	background-color: transparent;
	color: inherit;

	&[type='text'],
	&[type='search'],
	&[type='tel'],
	&[type='email'] {
		text-overflow: ellipsis;
	}

	&[type='number'] {
		&::-webkit-inner-spin-button {
			height: auto;
		}
		&::-webkit-outer-spin-button {
			height: auto;
		}
	}

	&[type='search'] {
		&::-webkit-search-cancel-button {
			-webkit-appearance: none;
		}
		&::-webkit-search-decoration {
			-webkit-appearance: none;
		}
	}

	&[type='file'] {
		padding: ${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['200'])};
		cursor: pointer;
	}

	&::placeholder {
		// added to overwrite core-ui styling, can be removed when core-ui is disabled
		font-style: normal;
		color: ${theme.colors.informative.textFormField};

		${stylePropertiesToCss(Object.assign({}, theme.typography.formFields['100FieldHintText']))}
	}

	&:focus {
		outline: none;
	}
`;
export const InputContainer = styled(Typography).attrs(() => ({
    tagName: 'input',
})) `
	${inputContainerStyles}
`;
/**
 * Input Wrapper
 */
export const inputWrapperStyles = ({ theme, $invalid, $colorContext, $color, $disabled, }) => css `
	display: flex;
	flex-direction: row;
	gap: ${pxToRem(theme.spacing['250'])};
	padding: ${pxToRem(theme.spacing['250'])};
	width: 100%;
	height: ${pxToRem(INPUT_HEIGHT)};
	border-style: solid;
	border-color: ${theme.colors.medium.borderFormField};
	border-width: 0 0 ${pxToRem(theme.borderWidth['2'])} 0;
	border-radius: ${theme.borderRadius.s}px ${theme.borderRadius.s}px 0 0;
	color: ${theme.colors.base.textFormFieldInput};
	background-color: ${theme.colors.extralight.bgFormField};

	${getGenericInputPaddingStyles({
    theme,
    $invalid,
    $color,
})}

	> :not(input) {
		flex: none;
	}

	${$colorContext === 'on-light' && getOnLightStyles({ theme, $invalid, $color })}

	${$colorContext === 'on-medium' && getOnMediumStyles({ theme, $invalid, $color })}

	${$colorContext === 'on-dark' && getOnDarkStyles({ theme, $invalid, $color })}
	
	${$disabled &&
    css `
		color: ${theme.colors.medium.textInactive};
		border-color: ${theme.colors.medium.borderFormField};
		background-color: ${theme.colors.extralight.bgFormFieldDisabled};

		${$colorContext === 'on-medium' &&
        css `
			color: ${theme.colors.medium.textInactiveOnMedium};
			background-color: ${theme.colors.light.bgFormFieldDisabledOnMedium};
		`}

		input::placeholder {
			color: ${theme.colors.medium.textInactive};
		}
	`}
`;
export const InputWrapper = styled.div `
	${inputWrapperStyles}
`;
/**
 * Input Icon
 */
export const inputIconStyles = ({ theme, $color, $disabled, }) => css `
	${$color === 'success' &&
    css `
		color: ${theme.colors.positive.iconCheck};
	`}

	${$color === 'error' &&
    css `
		color: ${theme.colors.error.iconError};
	`}

	${$disabled &&
    css `
		color: ${theme.colors.medium.iconInactive};
	`}
`;
export const InputIcon = styled(Icon) `
	${inputIconStyles}
`;
/**
 * Input Spinner
 */
export const inputSpinnerStyles = () => css `
	// This shouldn't be needed but is needed to be visually backwards compatible
	transform: translate(4px, -3px);
	opacity: 1;
	width: ${pxToRem(SPINNER_SIZE)};
	height: ${pxToRem(SPINNER_SIZE)};

	${SpinnerSVG} {
		width: ${pxToRem(SPINNER_SIZE)};
		height: ${pxToRem(SPINNER_SIZE)};
	}

	${SpinnerText} {
		white-space: nowrap;
	}
`;
export const InputSpinner = styled(Spinner) `
	${inputSpinnerStyles}
`;
//# sourceMappingURL=input.styled.js.map